import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useCart } from "@shopify/hydrogen";
import { useStoreCart } from "../store/modules/client/";
const Main = ({ children }) => {
  const { lines, totalQuantity } = useCart();
  const { navCartSlider, getNewQuantity, openCartNav, showSearchState, showMobileNavState } = useStoreCart();

  useEffect(() => {
    getNewQuantity(totalQuantity);
  }, [totalQuantity]);
  useEffect(() => {
    navCartSlider(lines);
  }, [lines]);


  const fixedPositionStyles =
    openCartNav || showSearchState || showMobileNavState;
  return (
    <>
      <div
        className={`${
          fixedPositionStyles ? "fixed inset-0 overflow-hidden" : ""
        }`}
      >
        <ToastContainer />
        {children}
      </div>
    </>
  );
};

export default Main;
